import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, BrainCircuit, Phone } from 'lucide-react';
import { siteConfig } from '../data';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Forside', path: '/' },
    { name: 'Forløb og priser', path: '/forloeb-og-priser' },
    { name: 'Mindsetforløb', path: '/mindsetforloeb' },
    { name: 'Om mig', path: '/om-mig' },
    { name: 'Kontakt', path: '/kontakt' },
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-sm">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-3 group">
              {siteConfig.images.logo ? (
                <img
                  src={siteConfig.images.logo}
                  alt="SECoaching Logo"
                  className="h-20 w-auto object-contain"
                />
              ) : (
                <div>
                  <span className="text-3xl sm:text-4xl font-extrabold tracking-tight text-blue-950 transition-colors group-hover:text-blue-900">
                    SE<span className="text-sky-500">Coaching</span>
                  </span>
                  <span className="block text-[11px] sm:text-xs uppercase tracking-widest text-slate-400 font-semibold -mt-1">
                    Mindset & Udvikling
                  </span>
                </div>
              )}
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative px-4 py-2.5 text-base font-semibold transition-colors duration-200 rounded-none ${
                  isActive(item.path)
                    ? 'text-black font-bold'
                    : 'text-slate-600 hover:text-black'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <div className="ml-4 h-6 w-px bg-slate-200" />
            <Link
              to="/kontakt"
              className="ml-4 inline-flex items-center gap-2 rounded-none bg-blue-950 px-5 py-2.5 text-sm font-semibold text-white hover:bg-blue-900 hover:-translate-y-1 active:scale-98 transition-all duration-300"
            >
              <Phone className="h-4 w-4 text-sky-400" />
              Book samtale
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center lg:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="inline-flex items-center justify-center rounded-none p-2.5 text-slate-500 hover:bg-slate-100 hover:text-blue-950 focus:outline-none"
              aria-controls="mobile-menu"
              aria-expanded="false"
            >
              <span className="sr-only">Åbn menu</span>
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="lg:hidden bg-white border-t border-slate-100" id="mobile-menu">
          <div className="space-y-1 px-4 pb-6 pt-3">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={`block rounded-none px-4 py-3 text-base font-semibold transition-colors ${
                  isActive(item.path)
                    ? 'text-black font-bold'
                    : 'text-slate-600 hover:text-black'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <div className="pt-4 border-t border-slate-100">
              <Link
                to="/kontakt"
                onClick={() => setIsOpen(false)}
                className="flex w-full items-center justify-center gap-2 rounded-none bg-blue-950 py-3.5 text-center text-base font-semibold text-white hover:bg-blue-900 hover:-translate-y-1 active:scale-98 transition-all duration-300"
              >
                <Phone className="h-5 w-5 text-sky-400" />
                Book en samtale
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
